import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const NavLink = ({
  dataLinkId,
  icon,
  iconClassName,
  iconContainerClassName,
  textClassName,
  copy,
  onClick,
}: {
  dataLinkId?: string;
  icon?: IconDefinition;
  iconClassName: string;
  iconContainerClassName: string;
  textClassName: string;
  copy: string;
  onClick: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}) => {
  return (
    <a
      href="#"
      className={iconContainerClassName}
      data-link-id={dataLinkId}
      onClick={ev => {
        ev.preventDefault();
        onClick(ev);
      }}
      data-dd-privacy="allow"
    >
      {icon && <FontAwesomeIcon icon={icon} className={iconClassName} />}
      <span className={textClassName}>{copy}</span>
    </a>
  );
};

export default NavLink;
